/**
 * English Translations - Shared
 *
 * Translations shared between frontend and backend (single source of truth).
 * Keys use dot notation: namespace.key
 *
 * Only add keys here when the SAME message text must be used by both
 * frontend and backend. Feature-specific translations stay in their app.
 */

import type { TranslationDictionaryType } from "../types/i18n.interface";

export const en = {
  "shared.whatsapp.connectedMessage":
    "Hi {{otherName}}, this is {{userName}}. We just connected for {{eventName}}. When is a good time to chat?",

  "invitations.openInvitation.defaultPhrase":
    "Hi Porter, I'm part of {{eventName}}",

  "shared.connectionCard.suggested": "Suggested",
  "shared.connectionCard.wantsToMeet": "Wants to meet you",
  "shared.connectionCard.nowConnected": "Now Connected",
  "shared.profile.subtitle.withCompany": "{{position}} at {{company}}",

  "featureConfig.form.schemaForm.helperText.daysBeforeEventStart":
    "Leave empty to enrich as soon as participants are added.",
} as const satisfies TranslationDictionaryType;

declare module "../types/translation-key.types.js" {
  interface TranslationKeyRegistry {
    shared: keyof typeof en;
  }
  interface TranslationValueRegistry {
    shared: typeof en;
  }
}
